module.exports = __webpack_public_path__ + "static/img/3.de851b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/99/zh/3.png
// module id = FWYV
// module chunks = 0